export function waitForAccessToken(): Promise<string> {
  const timeout = 10000;
  const start = Date.now();
  return new Promise(ensureTokenIsSet);

  function ensureTokenIsSet(this: any, resolve: any, reject: any) {
    if ((window as any)['coveoAccessToken']) {
      resolve((window as any)['coveoAccessToken']);
    } else if (timeout && (Date.now() - start) >= timeout) {
      reject(new Error("timeout waiting for access token"));
    } else {
      setTimeout(ensureTokenIsSet.bind(this, resolve, reject), 30);
    }
  }
}